<!-- https://www.vue-tailwind.com/docs/select -->
<template>
  <div class="relative">
    <t-select
      v-model="selectedOption"
      :variant="variant"
      class="p-1 focus:ring-2 focus:outline-none focus:ring-opacity-50"
      :value="selectedOption"
      :disabled="isDisabled"
      @update:model-value="setSelected"
    >
      <t-select-trigger
        :variant="variant"
        select-icon="chevron-down"
        :select-icon-variant="variant === 'courseMobile' ? 'courseMobile' : 'ceTracker'"

      >
        <t-select-value :placeholder="label" />
      </t-select-trigger>
      <t-select-content>
        <t-select-item
          v-for="profession in professionList"
          :key="profession[valueKey]"
          :value="profession[valueKey]"
          class="justify-start"
        >
          {{ profession[labelKey] }}
        </t-select-item>
      </t-select-content>
    </t-select>
  </div>
</template>

<script>
import professions from '@/data/profession.json';
import certProfessions from '@/data/certificateProfessions.json';
import distinctProfessions from '@/data/distinctProfessions.json';
import ceValidatorProfessions from '@/data/ceValidatorProfessions.json';

export default {
  name: 'ProfessionOptions',
  props: {
    label: {
      type: String,
      default: 'Profession',
    },
    modelValue: {
      type: [Object, String],
      default: () => ({}),
    },
    variant: {
      type: String,
      default: 'signup',
    },
    labelKey: {
      type: String,
      default: 'name',
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    professionListVariant: {
      type: String,
      default: 'professions',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      professionList: [],
      selectedOption: this.modelValue[this.valueKey],
    };
  },

  computed: {
    determineProfessionList() {
      switch (this.professionListVariant) {
        case 'professions':
          return Object.values(professions);
        case 'certProfessions':
          return Object.values(certProfessions);
        case 'distinctProfessions':
          return Object.values(distinctProfessions);
        case 'ceValidatorProfessions':
          return Object.values(ceValidatorProfessions);
        default:
          return Object.values(professions);
      }
    },
  },
  watch: {
    modelValue(newProfession) {
      this.selectedOption = newProfession[this.valueKey];
    },
  },
  mounted() {
    this.professionList = this.determineProfessionList;
  },
  // This is how the v-model works when using nested components.
  // This is not always needed, but probably if a nested `v-model` is used.
  methods: {
    getProfessionObject(newProfession) {
      const isString = typeof newProfession === 'string';
      const selectedState = this.professionList.find((profession) => {
        if (isString) {
          return profession.id.toString() === newProfession || profession.name === newProfession;
        }
        else {
          return profession.id === newProfession;
        }
      });
      return selectedState && Object.freeze({
        ...selectedState,
        type: 'profession',
      });
    },
    setSelected(newValue) {
      this.$emit('update:modelValue', this.getProfessionObject(newValue));
    },
  },
};
</script>
